import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as GalleryAdd} from "assets/img/gallery-add.svg";
import {greyishBlue300} from "assets/jss/main";

GalleryAddIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(GalleryAdd)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true && {
            stroke: greyishBlue300
        }
    },
}));

export default function GalleryAddIcon(props) {
    return <StyledSvg {...props} />;
}
